<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-7 col-md-7 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          Buyers &nbsp;
          <add-button link="/procurement-management/buyers/create"></add-button>
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-5 col-sm-6 col-md-5 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Procurement Management</li>
          <li class="breadcrumb-item">Buyers</li>
          <li class="breadcrumb-item active" aria-current="page">List</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Search & Filtering  -->
    <div class="col-md-12 grid-margin stretch-card">
      <div class="card">
        <div class="card-body">
          <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
            <input
              type="text"
              class="form-control"
              placeholder="Search..."
              v-model="searchData"
              @keydown.enter="search"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- Search & Filtering  -->
    <!-- Table -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Export To Excel -->
            <div class="row">
              <div class="col-md-8"></div>
              <div class="col-md-4">
                <div style="float: right">
                  <a
                    href="#"
                    class="btn btn-primary"
                    v-if="Exportbuyers.length == 0"
                    @click="exportToExcel"
                  >
                    <span v-if="isExcelloading">
                      <div class="d-flex align-items-center">
                        <strong>Generating Excel</strong>
                        &nbsp;
                        <div
                          class="
                            spinner-border
                            text-light
                            spinner-border-sm
                            ms-auto
                          "
                          role="status"
                          aria-hidden="true"
                        ></div>
                      </div>
                    </span>
                    <span v-else>Generate Excel</span>
                  </a>
                  <download-excel
                    :title="title"
                    v-else
                    class="btn btn-success"
                    :data="buyers_excel"
                    :fields="excel_fields"
                    worksheet="Buyers"
                    name="Buyer.xls"
                    >Download Excel
                  </download-excel>
                </div>
              </div>
            </div>
            <br />
            <!-- End Export to Excel -->
            <div class="table-responsive">
              <table id="dataTableExample" class="table table-hover">
                <thead>
                  <tr>
                    <th>Sr No</th>
                    <th>Name</th>
                    <th>Address</th>
                    <th>Country</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Fax Number</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Table Loader -->
                  <loading-table
                    :isLoading="isLoading"
                    cols="8
                        "
                  ></loading-table>
                  <!-- If No Data Received-->
                  <tr v-if="buyers.length == 0">
                    <td colspan="8" class="text-center" style="color: grey">
                      No Data Found
                    </td>
                  </tr>
                  <!-- If data Received -->
                  <tr v-for="(buyer, at) in buyers" :key="`buyer${at}`">
                    <td>{{ serialNoStarting + at + 1 }}</td>
                    <td>{{ buyer.name }}</td>
                    <td>{{ buyer.address }}</td>
                    <td>{{ buyer.country.name }}</td>
                    <td>{{ buyer.email }}</td>
                    <td>{{ buyer.phone }}</td>
                    <td>{{ buyer.fax_no }}</td>
                    <td>
                      <div>
                        <router-link
                          :to="`/procurement-management/buyers/${buyer.id}`"
                          tag="button"
                          class="btn btn-primary btn-sm"
                          >Edit</router-link
                        >
                        &nbsp; &nbsp;
                        <button
                          class="btn btn-danger btn-sm"
                          @click="delete_data(buyer.id)"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <!-- /Table -->
            </div>
            <pagination :count="count" @submit="getData"></pagination>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";

export default {
  name: "buyer",
  data() {
    return {
      buyers: [],
      count: 0,
      serialNoStarting: 1,
      isLoading: false,
      isExcelloading: false,
      searchData: "",
      buyers_excel: [],
      excel_fields: {
        "Sr No": "sr_no",
        Name: "name",
        Address: "address",
        Country: "country",
        Email: "email",
        Phone: "phone",
        "Fax Number": "fax_no",
      },
      Exportbuyers: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // async getData() {
    async getData(page = 1) {
      this.isLoading = true;
      let buyers = await axios.get(
        `/buyers?page=${page}&rowsPerPage=${this.rowsPerPage}`
      );
      this.buyers = buyers.data.data;
      this.count = buyers.data.count;
      this.serialNoStarting = (page - 1) * this.rowsPerPage;
      this.isLoading = false;
    },
    async search() {
      this.isLoading = true;
      let buyers = await axios.get(`/buyers?search=${this.searchData}`);
      this.buyers = buyers.data.data;
      this.count = buyers.data.count;
      this.isLoading = false;
    },
    async exportToExcel() {
      this.isExcelloading = true;
      this.title = "Buyer Data";
      this.buyers_excel = [];
      let Exportbuyers = [];
      Exportbuyers = await axios.get(`/buyers`);
      this.Exportbuyers = Exportbuyers.data.data;
      let sr_no = 1;
      this.Exportbuyers.forEach((buyer) => {
        this.buyers_excel.push({
          sr_no: sr_no,
          name: buyer.name ? buyer.name : "",
          address: buyer.address ? buyer.address : "",
          country: buyer.country ? buyer.country.name : "",
          email: buyer.email ? buyer.email : "",
          phone: buyer.phone ? buyer.phone : "",
          fax_no: buyer.fax_no ? buyer.fax_no : "",
        });
        sr_no++;
      });
      this.isExcelloading = false;
    },
    async delete_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=buyers`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
